<template>
    <Field
        :type="type"
        :label="label"
        :key="roleOptions.length"
        :disabled="disabled"
        v-model="selectedRole"
        :required="required"
        :plain-text-mode="plainTextMode"
        :params="{ options: roleOptions, placeholder: placeholder }"
    />
</template>

<script>
import Field from '@/components/Field.vue';

export default {
    name: 'RoleDropdownField',
    components: {
        Field,
    },
    props: {
        modelValue: {
            type: [String, Number, Array],
            default: null,
        },
        label: {
            type: String,
            default: 'Role',
        },
        type: {
            type: String,
            default: 'select',
        },
        required: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: 'Select a role',
        },
        plainTextMode: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:modelValue'],
    computed: {
        roleOptions() {
            return this.$roleStore.getRoleOptions || [];
        },
        selectedRole: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
    },
};
</script>

<style scoped></style>
